import { TbVaccineBottle } from "react-icons/tb";

export const productType = [
  {
    id: 1,
    cardText: "BLOOD",
  },
  {
    id: 2,
    cardText: "OXYGEN",
  },
  {
    id: 3,
    cardText: "STOCKBANK",
  },
  {
    id: 4,
    cardText: "OTHERS",
  },
];

export const bloodComponents = [
  {
    id: 1,
    bloodComponent: "PLATELET",
  },
  {
    id: 2,
    bloodComponent: "CRYOPRECIPITATE",
  },
  {
    id: 3,
    bloodComponent: "WHOLE BLOOD",
  },
  {
    id: 4,
    bloodComponent: "FRESH FROZEN PLASMA",
  },
  {
    id: 5,
    bloodComponent: "PACKED RED BLOOD CELLS",
  },
  {
    id: 6,
    bloodComponent: "OTHERS",
  },
];

export const bloodGroup = [
  {
    id: 1,
    bloodGroup: "A+",
  },
  {
    id: 2,
    bloodGroup: "A-",
  },
  {
    id: 3,
    bloodGroup: "B+",
  },
  {
    id: 4,
    bloodGroup: "B-",
  },
  {
    id: 5,
    bloodGroup: "O+",
  },
  {
    id: 6,
    bloodGroup: "O-",
  },
  {
    id: 7,
    bloodGroup: "AB+",
  },
  {
    id: 8,
    bloodGroup: "AB-",
  },
  {
    id: 9,
    bloodGroup: "UNSURE",
  },
];

export const genotype = [
  {
    id: 1,
    genotype: "AA",
  },
  {
    id: 2,
    genotype: "AS",
  },
  {
    id: 3,
    genotype: "AC",
  },
  {
    id: 4,
    genotype: "CC",
  },
  {
    id: 5,
    genotype: "SC",
  },
  {
    id: 6,
    genotype: "SS",
  },
  {
    id: 7,
    genotype: "UNSURE",
  },
];

export const payments = [
  {
    id: 1,
    label: "BANK TRANSFER",
  },
  {
    id: 2,
    label: "CASH ON DELIVERY",
  },
  {
    id: 3,
    label: "CHEQUE",
  },
  {
    id: 4,
    label: "HMO",
  },
];

export const editComponent = [
  {
    id: 1,
    label: "PAYMENT",
  },
  {
    id: 2,
    label: "DISPATCH",
  },
  {
    id: 3,
    label: "VENDOR",
  },
  {
    id: 4,
    label: "COMPONENT",
  },
  {
    id: 5,
    label: "QUANTITY",
  },
];

export const oxygenOrder = [
  {
    id: 1,
    label: "REFILL",
  },
  {
    id: 2,
    label: "EXCHANGE",
  },
  {
    id: 3,
    label: "DROP OFF",
  },
];

export const reasons = [
  {
    id: 1,
    reason: "GENERAL SURGERY",
  },
  {
    id: 2,
    reason: "BLOOD LOSS FROM ACCIDENT",
  },
  // {
  //   id: 3,
  //   reason: "WHOLE BLOOD",
  // },
  {
    id: 4,
    reason: "INTENSIVE CARE TREATMENT",
  },
  {
    id: 5,
    reason: "TREATMENT OF NEWBORN BABIES & CHILDREN",
  },
  {
    id: 6,
    reason: "ORTHOPAEDIC",
  },
  {
    id: 7,
    reason: "RENAL SURGERY",
  },
  {
    id: 8,
    reason: "POST PARTUM HEMORRAGE",
  },
  {
    id: 9,
    reason: "OTHERS",
  },
];

export const oxygenReasons = [
  {
    id: 1,
    reason: "GENERAL SURGERY",
  },
  {
    id: 2,
    reason: "PNEUMONIA",
  },

  {
    id: 3,
    reason: "COVID",
  },
  {
    id: 4,
    reason: "ASTHMA",
  },
  {
    id: 5,
    reason: "UPPER RESPITORY TRACT INFECTION",
  },
  {
    id: 6,
    reason: "LOWER RESPITORY TRACT INFECTION",
  },
  {
    id: 7,
    reason: "OTHERS",
  },
];

export const stockbank = [
  {
    id: 1,
    name: "Surgical Gloves 7’",
    desc: "8PPKTS/CTN",
    price: 7000,
    qty: 1,
  },
  {
    id: 2,
    name: "Universal Sample Bottle",
    desc: "25PCS PER PACK",
    price: 1900,
    qty: 1,
  },
  {
    id: 3,
    name: "25PCS PER PACK",
    desc: "12PCS/PACK, 50PKS/CARTON",
    price: 4500,
    qty: 1,
  },
  {
    id: 4,
    name: "10ml Syringes & Needles",
    desc: "8P100PCS/PACK, 12PKS/CTN",
    price: 6500,
    qty: 1,
  },
];

export const cylinderSize = [
  {
    id: 1,
    size: "0.5 Cubic Meter",
  },
  {
    id: 2,
    size: "1 Cubic Meter",
  },
  {
    id: 3,
    size: "1.5 Cubic Meter",
  },
  {
    id: 4,
    size: "1.6 Cubic Meter",
  },
  {
    id: 5,
    size: "2 Cubic Meter",
  },
  {
    id: 6,
    size: "2.5 Cubic Meter",
  },
  {
    id: 7,
    size: "3 Cubic Meter",
  },
  {
    id: 8,
    size: "4 Cubic Meter",
  },
  {
    id: 9,
    size: "5 Cubic Meter",
  },
  {
    id: 10,
    size: "6 Cubic Meter",
  },
  {
    id: 11,
    size: "7 Cubic Meter",
  },
  {
    id: 12,
    size: "7.5 Cubic Meter",
  },
  {
    id: 13,
    size: "8 Cubic Meter",
  },
  {
    id: 14,
    size: "9 Cubic Meter",
  },
  {
    id: 15,
    size: "10 Cubic Meter",
  },
];

export const cylinderCategory = [
  {
    id: 1,
    size: "Small Cylinder",
    icon: <TbVaccineBottle size={40} color="white" />,
  },
  {
    id: 2,
    size: "Medium Cylinder",
    icon: <TbVaccineBottle size={40} color="white" />,
  },
  {
    id: 3,
    size: "Large Cylinder",
    icon: <TbVaccineBottle size={40} color="white" />,
  },
];

export const locations = [
  {
    id: 1,
    lat: 6.4471696,
    lng: 3.5178536,
  },
  {
    id: 2,
    lat: 6.4760679,
    lng: 3.6170514,
  },
  {
    id: 3,
    lat: 6.4760679,
    lng: 3.6170514,
  },
  {
    id: 4,
    lat: 6.4760679,
    lng: 3.6170514,
  },
  {
    id: 5,
    lat: 9.1075535,
    lng: 7.4176679,
  },
];

export const editType = [
  {
    id: 1,
    label: "PAYMENT",
  },
  {
    id: 2,
    label: "DISPATCH",
  },
  {
    id: 3,
    label: "VENDOR",
  },

  {
    id: 4,
    label: "QUANTITY",
  },
];

export const editHospitalType = [
  {
    id: 1,
    label: "ADDRESS",
  },
  {
    id: 2,
    label: "CLASS",
  },
  {
    id: 3,
    label: "PHONE NUMBER",
  },
];
export const editCradleType = [
  {
    id: 1,
    label: "Class",
  },
 
];

export const vType = [
  {
    id: 1,
    label: "ADDRESS",
  },

  {
    id: 2,
    label: "PHONE NUMBER",
  },
  {
    id: 3,
    label: "EMAIL",
  },
];

export const trackOptions = [
  {
    value: 0,
    label: "Bike",
  },

  {
    value: 1,
    label: "Phone",
  },
];

export const topics = [
  {
    value: "Error",
    label: "Error",
  },
  {
    value: "Vendor for Special Request",
    label: "Vendor for Special Request",
  },
  {
    value: "Product Not Available",
    label: "Product Not Available",
  },
  {
    value: "hospital ask to cancel",
    label: "Hospital Ask To Cancel",
  },
  {
    value: "Late Delivery",
    label: "Late Delivery",
  },
];

export const delay = [
  {
    value: "Fuel issues",
    label: "Fuel issues",
  },
  {
    value: "Rider Issues",
    label: "Rider Issues",
  },
  {
    value: "Asset issues",
    label: "Asset issues",
  },
  {
    value: " Vendor",
    label: " Vendor",
  },
];

export const states = [
  {
    code: "FC",
    name: "Abuja",
    lgas: ["Abuja", "Kwali", "Kuje", "Gwagwalada", "Bwari", "Abaji"],
  },
  {
    code: "AB",
    name: "Abia",
    lgas: [
      "Aba North",
      "Aba South",
      "Arochukwu",
      "Bende",
      "Ikawuno",
      "Ikwuano",
      "Isiala-Ngwa North",
      "Isiala-Ngwa South",
      "Isuikwuato",
      "Umu Nneochi",
      "Obi Ngwa",
      "Obioma Ngwa",
      "Ohafia",
      "Ohaozara",
      "Osisioma",
      "Ugwunagbo",
      "Ukwa West",
      "Ukwa East",
      "Umuahia North",
      "Umuahia South",
    ],
  },
  {
    code: "AD",
    name: "Adamawa",
    lgas: [
      "Demsa",
      "Fufore",
      "Ganye",
      "Girei",
      "Gombi",
      "Guyuk",
      "Hong",
      "Jada",
      "Lamurde",
      "Madagali",
      "Maiha",
      "Mayo-Belwa",
      "Michika",
      "Mubi-North",
      "Mubi-South",
      "Numan",
      "Shelleng",
      "Song",
      "Toungo",
      "Yola North",
      "Yola South",
    ],
  },
  {
    code: "AK",
    name: "AkwaIbom",
    lgas: [
      "Abak",
      "Eastern-Obolo",
      "Eket",
      "Esit-Eket",
      "Essien-Udim",
      "Etim-Ekpo",
      "Etinan",
      "Ibeno",
      "Ibesikpo-Asutan",
      "Ibiono-Ibom",
      "Ika",
      "Ikono",
      "Ikot-Abasi",
      "Ikot-Ekpene",
      "Ini",
      "Itu",
      "Mbo",
      "Mkpat-Enin",
      "Nsit-Atai",
      "Nsit-Ibom",
      "Nsit-Ubium",
      "Obot-Akara",
      "Okobo",
      "Onna",
      "Oron",
      "Oruk Anam",
      "Udung-Uko",
      "Ukanafun",
      "Urue-Offong/Oruko",
      "Uruan",
      "Uyo",
    ],
  },
  {
    code: "AN",
    name: "Anambra",
    lgas: [
      "Aguata",
      "Anambra East",
      "Anambra West",
      "Anaocha",
      "Awka North",
      "Awka South",
      "Ayamelum",
      "Dunukofia",
      "Ekwusigo",
      "Idemili-North",
      "Idemili-South",
      "Ihiala",
      "Njikoka",
      "Nnewi-North",
      "Nnewi-South",
      "Ogbaru",
      "Onitsha-North",
      "Onitsha-South",
      "Orumba-North",
      "Orumba-South",
    ],
  },
  {
    code: "BA",
    name: "Bauchi",
    lgas: [
      "Alkaleri",
      "Bauchi",
      "Bogoro",
      "Damban",
      "Darazo",
      "Dass",
      "Gamawa",
      "Ganjuwa",
      "Giade",
      "Itas Gadau",
      "Jama'Are",
      "Katagum",
      "Kirfi",
      "Misau",
      "Ningi",
      "Shira",
      "Tafawa-Balewa",
      "Toro",
      "Warji",
      "Zaki",
    ],
  },
  {
    code: "BY",
    name: "Bayelsa",
    lgas: [
      "Brass",
      "Ekeremor",
      "Kolokuma Opokuma",
      "Nembe",
      "Ogbia",
      "Sagbama",
      "Southern-Ijaw",
      "Yenagoa",
    ],
  },
  {
    code: "BE",
    name: "Benue",
    lgas: [
      "Ado",
      "Agatu",
      "Apa",
      "Buruku",
      "Gboko",
      "Guma",
      "Gwer-East",
      "Gwer-West",
      "Katsina-Ala",
      "Konshisha",
      "Kwande",
      "Logo",
      "Makurdi",
      "Ogbadibo",
      "Ohimini",
      "Oju",
      "Okpokwu",
      "Otukpo",
      "Tarka",
      "Ukum",
      "Ushongo",
      "Vandeikya",
    ],
  },
  {
    code: "BO",
    name: "Borno",
    lgas: [
      "Abadam",
      "Askira-Uba",
      "Bama",
      "Bayo",
      "Biu",
      "Chibok",
      "Damboa",
      "Dikwa",
      "Gubio",
      "Guzamala",
      "Gwoza",
      "Hawul",
      "Jere",
      "Kaga",
      "Kala Balge",
      "Konduga",
      "Kukawa",
      "Kwaya-Kusar",
      "Mafa",
      "Magumeri",
      "Maiduguri",
      "Marte",
      "Mobbar",
      "Monguno",
      "Ngala",
      "Nganzai",
      "Shani",
    ],
  },
  {
    code: "CR",
    name: "CrossRiver",
    lgas: [
      "Abi",
      "Akamkpa",
      "Akpabuyo",
      "Bakassi",
      "Bekwarra",
      "Biase",
      "Boki",
      "Calabar-Municipal",
      "Calabar-South",
      "Etung",
      "Ikom",
      "Obanliku",
      "Obubra",
      "Obudu",
      "Odukpani",
      "Ogoja",
      "Yakurr",
      "Yala",
    ],
  },
  {
    code: "DE",
    name: "Delta",
    lgas: [
      "Aniocha North",
      "Aniocha-North",
      "Aniocha-South",
      "Bomadi",
      "Burutu",
      "Ethiope-East",
      "Ethiope-West",
      "Ika-North-East",
      "Ika-South",
      "Isoko-North",
      "Isoko-South",
      "Ndokwa-East",
      "Ndokwa-West",
      "Okpe",
      "Oshimili-North",
      "Oshimili-South",
      "Patani",
      "Sapele",
      "Udu",
      "Ughelli-North",
      "Ughelli-South",
      "Ukwuani",
      "Uvwie",
      "Warri South-West",
      "Warri North",
      "Warri South",
    ],
  },
  {
    code: "EB",
    name: "Ebonyi",
    lgas: [
      "Abakaliki",
      "Afikpo-North",
      "Afikpo South (Edda)",
      "Ebonyi",
      "Ezza-North",
      "Ezza-South",
      "Ikwo",
      "Ishielu",
      "Ivo",
      "Izzi",
      "Ohaukwu",
      "Onicha",
    ],
  },
  {
    code: "ED",
    name: "Edo",
    lgas: [
      "Akoko Edo",
      "Egor",
      "Esan-Central",
      "Esan-North-East",
      "Esan-South-East",
      "Esan-West",
      "Etsako-Central",
      "Etsako-East",
      "Etsako-West",
      "Igueben",
      "Ikpoba-Okha",
      "Oredo",
      "Orhionmwon",
      "Ovia-North-East",
      "Ovia-South-West",
      "Owan East",
      "Owan-West",
      "Uhunmwonde",
    ],
  },
  {
    code: "EK",
    name: "Ekiti",
    lgas: [
      "Ado-Ekiti",
      "Efon",
      "Ekiti-East",
      "Ekiti-South-West",
      "Ekiti-West",
      "Emure",
      "Gbonyin",
      "Ido-Osi",
      "Ijero",
      "Ikere",
      "Ikole",
      "Ilejemeje",
      "Irepodun Ifelodun",
      "Ise-Orun",
      "Moba",
      "Oye",
    ],
  },
  {
    code: "EN",
    name: "Enugu",
    lgas: [
      "Aninri",
      "Awgu",
      "Enugu-East",
      "Enugu-North",
      "Enugu-South",
      "Ezeagu",
      "Igbo-Etiti",
      "Igbo-Eze-North",
      "Igbo-Eze-South",
      "Isi-Uzo",
      "Nkanu-East",
      "Nkanu-West",
      "Nsukka",
      "Oji-River",
      "Udenu",
      "Udi",
      "Uzo-Uwani",
    ],
  },
  {
    code: "GO",
    name: "Gombe",
    lgas: [
      "Akko",
      "Balanga",
      "Billiri",
      "Dukku",
      "Funakaye",
      "Gombe",
      "Kaltungo",
      "Kwami",
      "Nafada",
      "Shongom",
      "Yamaltu Deba",
    ],
  },
  {
    code: "IM",
    name: "Imo",
    lgas: [
      "Aboh-Mbaise",
      "Ahiazu-Mbaise",
      "Ehime-Mbano",
      "Ezinihitte",
      "Ideato-North",
      "Ideato-South",
      "Ihitte Uboma",
      "Ikeduru",
      "Isiala-Mbano",
      "Isu",
      "Mbaitoli",
      "Ngor-Okpala",
      "Njaba",
      "Nkwerre",
      "Nwangele",
      "Obowo",
      "Oguta",
      "Ohaji-Egbema",
      "Okigwe",
      "Onuimo",
      "Orlu",
      "Orsu",
      "Oru-East",
      "Oru-West",
      "Owerri-Municipal",
      "Owerri-North",
      "Owerri-West",
    ],
  },
  {
    code: "JI",
    name: "Jigawa",
    lgas: [
      "Auyo",
      "Babura",
      "Biriniwa",
      "Birnin-Kudu",
      "Buji",
      "Dutse",
      "Gagarawa",
      "Garki",
      "Gumel",
      "Guri",
      "Gwaram",
      "Gwiwa",
      "Hadejia",
      "Jahun",
      "Kafin-Hausa",
      "Kaugama",
      "Kazaure",
      "Kiri kasama",
      "Maigatari",
      "Malam Madori",
      "Miga",
      "Ringim",
      "Roni",
      "Sule-Tankarkar",
      "Taura",
      "Yankwashi",
    ],
  },
  {
    code: "KD",
    name: "Kaduna",
    lgas: [
      "Birnin-Gwari",
      "Chikun",
      "Giwa",
      "Igabi",
      "Ikara",
      "Jaba",
      "Jema'A",
      "Kachia",
      "Kaduna-North",
      "Kaduna-South",
      "Kagarko",
      "Kajuru",
      "Kaura",
      "Kauru",
      "Kubau",
      "Kudan",
      "Lere",
      "Makarfi",
      "Sabon-Gari",
      "Sanga",
      "Soba",
      "Zangon-Kataf",
      "Zaria",
    ],
  },
  {
    code: "KN",
    name: "Kano",
    lgas: [
      "Ajingi",
      "Albasu",
      "Bagwai",
      "Bebeji",
      "Bichi",
      "Bunkure",
      "Dala",
      "Dambatta",
      "Dawakin-Kudu",
      "Dawakin-Tofa",
      "Doguwa",
      "Fagge",
      "Gabasawa",
      "Garko",
      "Garun-Mallam",
      "Gaya",
      "Gezawa",
      "Gwale",
      "Gwarzo",
      "Kabo",
      "Kano-Municipal",
      "Karaye",
      "Kibiya",
      "Kiru",
      "Kumbotso",
      "Kunchi",
      "Kura",
      "Madobi",
      "Makoda",
      "Minjibir",
      "Nasarawa",
      "Rano",
      "Rimin-Gado",
      "Rogo",
      "Shanono",
      "Sumaila",
      "Takai",
      "Tarauni",
      "Tofa",
      "Tsanyawa",
      "Tudun-Wada",
      "Ungogo",
      "Warawa",
      "Wudil",
    ],
  },
  {
    code: "KT",
    name: "Katsina",
    lgas: [
      "Bakori",
      "Batagarawa",
      "Batsari",
      "Baure",
      "Bindawa",
      "Charanchi",
      "Dan-Musa",
      "Dandume",
      "Danja",
      "Daura",
      "Dutsi",
      "Dutsin-Ma",
      "Faskari",
      "Funtua",
      "Ingawa",
      "Jibia",
      "Kafur",
      "Kaita",
      "Kankara",
      "Kankia",
      "Katsina",
      "Kurfi",
      "Kusada",
      "Mai-Adua",
      "Malumfashi",
      "Mani",
      "Mashi",
      "Matazu",
      "Musawa",
      "Rimi",
      "Sabuwa",
      "Safana",
      "Sandamu",
      "Zango",
    ],
  },
  {
    code: "KE",
    name: "Kebbi",
    lgas: [
      "Aleiro",
      "Arewa-Dandi",
      "Argungu",
      "Augie",
      "Bagudo",
      "Birnin-Kebbi",
      "Bunza",
      "Dandi",
      "Fakai",
      "Gwandu",
      "Jega",
      "Kalgo",
      "Koko-Besse",
      "Maiyama",
      "Ngaski",
      "Sakaba",
      "Shanga",
      "Suru",
      "Wasagu/Danko",
      "Yauri",
      "Zuru",
    ],
  },
  {
    code: "KO",
    name: "Kogi",
    lgas: [
      "Adavi",
      "Ajaokuta",
      "Ankpa",
      "Dekina",
      "Ibaji",
      "Idah",
      "Igalamela-Odolu",
      "Ijumu",
      "Kabba Bunu",
      "Kogi",
      "Lokoja",
      "Mopa-Muro",
      "Ofu",
      "Ogori Magongo",
      "Okehi",
      "Okene",
      "Olamaboro",
      "Omala",
      "Oyi",
      "Yagba-East",
      "Yagba-West",
    ],
  },
  {
    code: "KW",
    name: "Kwara",
    lgas: [
      "Asa",
      "Baruten",
      "Edu",
      "Ekiti (Araromi/Opin)",
      "Ilorin-East",
      "Ilorin-South",
      "Ilorin-West",
      "Isin",
      "Kaiama",
      "Moro",
      "Offa",
      "Oke-Ero",
      "Oyun",
      "Pategi",
    ],
  },
  {
    code: "LA",
    name: "Lagos",
    lgas: [
      "Agege",
      "Ajeromi-Ifelodun",
      "Alimosho",
      "Amuwo-Odofin",
      "Apapa",
      "Badagry",
      "Epe",
      "Eti-Osa",
      "Ibeju-Lekki",
      "Ifako-Ijaiye",
      "Ikeja",
      "Ikorodu",
      "Kosofe",
      "Lagos-Island",
      "Lagos-Mainland",
      "Mushin",
      "Ojo",
      "Oshodi-Isolo",
      "Shomolu",
      "Surulere",
      "Yewa-South",
    ],
  },
  {
    code: "NA",
    name: "Nassarawa",
    lgas: [
      "Akwanga",
      "Awe",
      "Doma",
      "Karu",
      "Keana",
      "Keffi",
      "Kokona",
      "Lafia",
      "Nasarawa",
      "Nasarawa-Eggon",
      "Obi",
      "Wamba",
      "Toto",
    ],
  },
  {
    code: "NI",
    name: "Niger",
    lgas: [
      "Agaie",
      "Agwara",
      "Bida",
      "Borgu",
      "Bosso",
      "Chanchaga",
      "Edati",
      "Gbako",
      "Gurara",
      "Katcha",
      "Kontagora",
      "Lapai",
      "Lavun",
      "Magama",
      "Mariga",
      "Mashegu",
      "Mokwa",
      "Moya",
      "Paikoro",
      "Rafi",
      "Rijau",
      "Shiroro",
      "Suleja",
      "Tafa",
      "Wushishi",
    ],
  },
  {
    code: "OG",
    name: "Ogun",
    lgas: [
      "Abeokuta-North",
      "Abeokuta-South",
      "Ado-Odo Ota",
      "Ewekoro",
      "Ifo",
      "Ijebu-East",
      "Ijebu-North",
      "Ijebu-North-East",
      "Ijebu-Ode",
      "Ikenne",
      "Imeko-Afon",
      "Ipokia",
      "Obafemi-Owode",
      "Odeda",
      "Odogbolu",
      "Ogun-Waterside",
      "Remo-North",
      "Shagamu",
      "Yewa North",
    ],
  },
  {
    code: "ON",
    name: "Ondo",
    lgas: [
      "Akoko North-East",
      "Akoko North-West",
      "Akoko South-West",
      "Akoko South-East",
      "Akure-North",
      "Akure-South",
      "Ese-Odo",
      "Idanre",
      "Ifedore",
      "Ilaje",
      "Ile-Oluji-Okeigbo",
      "Irele",
      "Odigbo",
      "Okitipupa",
      "Ondo West",
      "Ondo-East",
      "Ose",
      "Owo",
    ],
  },
  {
    code: "OS",
    name: "Osun",
    lgas: [
      "Atakumosa West",
      "Atakumosa East",
      "Ayedaade",
      "Ayedire",
      "Boluwaduro",
      "Boripe",
      "Ede South",
      "Ede North",
      "Egbedore",
      "Ejigbo",
      "Ife North",
      "Ife South",
      "Ife-Central",
      "Ife-East",
      "Ifelodun",
      "Ila",
      "Ilesa-East",
      "Ilesa-West",
      "Irepodun",
      "Irewole",
      "Isokan",
      "Iwo",
      "Obokun",
      "Odo-Otin",
      "Ola Oluwa",
      "Olorunda",
      "Oriade",
      "Orolu",
      "Osogbo",
    ],
  },
  {
    code: "OY",
    name: "Oyo",
    lgas: [
      "Afijio",
      "Akinyele",
      "Atiba",
      "Atisbo",
      "Egbeda",
      "Ibadan North",
      "Ibadan North-East",
      "Ibadan North-West",
      "Ibadan South-East",
      "Ibadan South-West",
      "Ibarapa-Central",
      "Ibarapa-East",
      "Ibarapa-North",
      "Ido",
      "Ifedayo",
      "Irepo",
      "Iseyin",
      "Itesiwaju",
      "Iwajowa",
      "Kajola",
      "Lagelu",
      "Ogo-Oluwa",
      "Ogbomosho-North",
      "Ogbomosho-South",
      "Olorunsogo",
      "Oluyole",
      "Ona-Ara",
      "Orelope",
      "Ori-Ire",
      "Oyo-West",
      "Oyo-East",
      "Saki-East",
      "Saki-West",
      "Surulere",
    ],
  },
  {
    code: "PL",
    name: "Plateau",
    lgas: [
      "Barkin-Ladi",
      "Bassa",
      "Bokkos",
      "Jos-East",
      "Jos-North",
      "Jos-South",
      "Kanam",
      "Kanke",
      "Langtang-North",
      "Langtang-South",
      "Mangu",
      "Mikang",
      "Pankshin",
      "Qua'an Pan",
      "Riyom",
      "Shendam",
      "Wase",
    ],
  },
  {
    code: "RI",
    name: "Rivers",
    lgas: [
      "Abua Odual",
      "Ahoada-East",
      "Ahoada-West",
      "Akuku Toru",
      "Andoni",
      "Asari-Toru",
      "Bonny",
      "Degema",
      "Eleme",
      "Emuoha",
      "Etche",
      "Gokana",
      "Ikwerre",
      "Khana",
      "Obio Akpor",
      "Ogba-Egbema-Ndoni",
      "Ogba Egbema Ndoni",
      "Ogu Bolo",
      "Okrika",
      "Omuma",
      "Opobo Nkoro",
      "Oyigbo",
      "Port-Harcourt",
      "Tai",
    ],
  },
  {
    code: "SO",
    name: "Sokoto",
    lgas: [
      "Binji",
      "Bodinga",
      "Dange-Shuni",
      "Gada",
      "Goronyo",
      "Gudu",
      "Gwadabawa",
      "Illela",
      "Kebbe",
      "Kware",
      "Rabah",
      "Sabon Birni",
      "Shagari",
      "Silame",
      "Sokoto-North",
      "Sokoto-South",
      "Tambuwal",
      "Tangaza",
      "Tureta",
      "Wamako",
      "Wurno",
      "Yabo",
    ],
  },
  {
    code: "TA",
    name: "Taraba",
    lgas: [
      "Ardo-Kola",
      "Bali",
      "Donga",
      "Gashaka",
      "Gassol",
      "Ibi",
      "Jalingo",
      "Karim-Lamido",
      "Kurmi",
      "Lau",
      "Sardauna",
      "Takum",
      "Ussa",
      "Wukari",
      "Yorro",
      "Zing",
    ],
  },
  {
    code: "YO",
    name: "Yobe",
    lgas: [
      "Bade",
      "Bursari",
      "Damaturu",
      "Fika",
      "Fune",
      "Geidam",
      "Gujba",
      "Gulani",
      "Jakusko",
      "Karasuwa",
      "Machina",
      "Nangere",
      "Nguru",
      "Potiskum",
      "Tarmuwa",
      "Yunusari",
      "Yusufari",
    ],
  },
  {
    code: "ZA",
    name: "Zamfara",
    lgas: [
      "Anka",
      "Bakura",
      "Birnin Magaji/Kiyaw",
      "Bukkuyum",
      "Bungudu",
      "Gummi",
      "Gusau",
      "Isa",
      "Kaura-Namoda",
      "Kiyawa",
      "Maradun",
      "Maru",
      "Shinkafi",
      "Talata-Mafara",
      "Tsafe",
      "Zurmi",
    ],
  },
];

export const paymentMode = [
  {
    value: "POS",
    label: "POS",
  },
  {
    value: "CASH ON DELIVERY",
    label: "CASH ON DELIVERY",
  },
  {
    value: "BANK TRANSFER",
    label: "BANK TRANSFER",
  },
  {
    value: "CHEQUE",
    label: "CHEQUE",
  },
  {
    value: "BOAT",
    label: "BOAT",
  },
  {
    value: "HMO",
    label: "HMO",
  },
  {
    value: "RECEIVABLES",
    label: "RECEIVABLES",
  },
];

export const updateBloodComponent = [
  {
    id: 1,
    bloodComponent: "Platelet",
  },
  {
    id: 2,
    bloodComponent: "Cryoprecipitate",
  },
  {
    id: 3,
    bloodComponent: "Whole blood",
  },
  {
    id: 4,
    bloodComponent: "Fresh frozen plasma",
  },
  {
    id: 5,
    bloodComponent: "Packed red blood cells",
  },
];
